module.exports = { "default": require("core-js/library/fn/symbol/to-primitive"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/to-primitive.js
// module id = 342
// module chunks = 54